import { render, staticRenderFns } from "./EditOrganizationFacilities.vue?vue&type=template&id=fb52280e&scoped=true"
import script from "./EditOrganizationFacilities.vue?vue&type=script&lang=js"
export * from "./EditOrganizationFacilities.vue?vue&type=script&lang=js"
import style0 from "./EditOrganizationFacilities.vue?vue&type=style&index=0&id=fb52280e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb52280e",
  null
  
)

export default component.exports